import { Collapse, Icon } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import autobind from "autobind-decorator";
import React from "react";

import { CourseWrapper } from "common/entities/courseWrapper/CourseWrapper";
import { BlockView } from "common/views/block/BlockView.view";
import { BoxView } from "common/views/box/Box.view";
import { CardView } from "common/views/card/Card.view";
import ProgressBarView from "common/views/progressBar/ProgressBar.view";
import { IQueryMany, QueryMany } from "core/api/query";
import ContainerViewProvider from "core/components/containerViewProvider/ContainerViewProvider";
import ViewProvider from "core/components/ViewProvider";
import { IPanelProps, Panel } from "core/decorators/Panel";
import ProgramTrackProductsPanel from "../programTrackProducts/ProgramTrackProducts.panel";
import Config from "./Config";
import ProgramTrack from "./entities/ProgramTrack";
import labelProvider from './TracksProgram.labels';

interface IState {
	active: null | string;
}

const { Labels } = labelProvider;

@Panel({id: "program-tracks", configClass: Config, pageParams: true, labelProvider})
@QueryMany(ProgramTrack, {}, true)
export default class TracksProgramPanel extends React.Component<IPanelProps<Config> & IQueryMany<ProgramTrack>, IState> {

	constructor(props: IPanelProps<Config> & IQueryMany<ProgramTrack>) {
		super(props);
		this.state = { active: null };
	}

	@autobind
	public getQueryParams(): object {
		return {programId: this.props.pageParams.programId};
	}

	public render() {
		const { config, entities } = this.props;
		const { isCardThumbnail, showCourseProgress, showDescription, showEntryCount, showProgress, title } = config;

		const tracks = entities && entities.map((programTrack, i) => {

			/**
			 * must have programTrack to do anything
			 */
			if (!programTrack) {
				return null;
			}

			/**
			 * track fields
			 */
			const {
				id,
				name,
				description,
				progress,
				products
			} = programTrack;

			const isActive: boolean = id === this.state.active;

			/**
			 * actions passed to the track card
			 */
			const actions: any[] = [
				{
					text: isActive ? <Labels.HideCourses /> : <Labels.ShowCourses/>,
					onClick: () => this.toggleActive(programTrack)
				}
			];

			/**
			 * track description
			 * @config showDescription
			 */

			const trackDescription = showDescription && (
				<div
					className="no-reset"
					dangerouslySetInnerHTML={{
						__html: description || "No Description"
					}}
					style={{
						marginBottom: "15px"
					}}
				/>
			);

			/**
			 * track progress bar
			 * @config showProgress
			 */
			const progressVal: number = progress ? (progress.total > 0 ? (progress.completed || 0) / progress.total : 0) : 0;

			const trackProgress = showProgress && (
				<ProgressBarView
					value={progressVal}
					viewKey="track-progress"
				/>
			);


			const toggleIcon = (
				<Icon icon={isActive ? IconNames.CHEVRON_UP : IconNames.CHEVRON_DOWN} />
			);

			/**
			 * courses in the track
			 * @todo update this to do more stuff once the query is fixed
			 */
			const courses = products && products.map((p) => {

				if (!p.entry) {
					return null;
				}

				const courseWrapper = CourseWrapper.forEntry(p.entry);

				const courseName = courseWrapper.getTitle();

				const courseActions: any[] = [
					{
						text: <Labels.LaunchCourse/>,
						icon: IconNames.PLAY,
						onClick: () => courseWrapper.launchCourse()
					}
					/*,
					{
						text: <Label k="course.view">View Details</Label>,
						icon: IconNames.LIST_DETAIL_VIEW,
						onClick: () => courseWrapper.viewCourse()
					}
					*/
				];

				const courseProgress = showCourseProgress && (
					<ProgressBarView value={courseWrapper.getProgressPercent()} viewKey="track-product-progress" />
				);

				const courseItemProps = {
					actions: courseActions,
					thumbnailAlt: `course icon for ${courseName}`,
					thumbnailSrc: courseWrapper.getIconUrl()
				};


				return (
					<ViewProvider
						viewId={isCardThumbnail ? "card-thumbnail" : "card"}
						viewKey="track-product"
						{...courseItemProps as any}
					>
						<h4>{courseWrapper.getTitle()}</h4>
						{courseProgress}
					</ViewProvider>
				);
			});

			return (
				<BlockView viewKey="program-track-wrapper">
					<CardView viewKey="program-track-card">
						<h4>{name}</h4>
						{trackDescription}
						{trackProgress}
						{toggleIcon}
					</CardView>
					<Collapse isOpen={isActive}>
						<BlockView viewKey="track-products-wrapper">
							<ContainerViewProvider viewKey="track-products-list" viewId="rows-container">
								{courses}
							</ContainerViewProvider>
						</BlockView>
					</Collapse>
				</BlockView>
			);
		});

		return (
			<BoxView title={title} viewKey="program-tracks-box">
				{tracks}
			</BoxView>
		);
	}

	@autobind
	private toggleActive(track: ProgramTrack) {
		this.setState((state) => ({ active: state.active !== track.id ? track.id : null }));
	}
}



// WEBPACK FOOTER //
// ./src/panels/tracksProgram/TracksProgram.panel.tsx